module.exports = __webpack_public_path__ + "static/media/logo-blue-gray.d3e97a62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-blue-gray.png
// module id = 973
// module chunks = 4